import { render, staticRenderFns } from "./UpdateShortcut.vue?vue&type=template&id=246665c9"
import script from "./UpdateShortcut.vue?vue&type=script&lang=js"
export * from "./UpdateShortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports